module.exports = __webpack_public_path__ + "static/media/organic.1ad1823c.svg";